module.exports = __webpack_public_path__ + "img/icon_warning.df96387a.png";